import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/components/pagination/pagination.js';
      import {ObcPaginationValueChangeEvent, ObcPaginationNavigateEvent, PaginationVariant} from '@oicl/openbridge-webcomponents/dist/components/pagination/pagination.js';

      export interface Props {
     variant?: PaginationVariant;
     pages?: number;
     currentPage?: number;
     fullWidth?: boolean;
     disabled?: boolean
   }

      
  
      export type {ObcPaginationValueChangeEvent, ObcPaginationNavigateEvent, PaginationVariant} from '@oicl/openbridge-webcomponents/dist/components/pagination/pagination.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcPagination',
  props: {
    variant: {},
    pages: {},
    currentPage: {},
    fullWidth: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["value", "navigate"],
  setup(__props: any, { emit: __emit }) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      const emit = __emit;

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    onValue: (event: ObcPaginationValueChangeEvent) => emit('value', event as ObcPaginationValueChangeEvent),
onNavigate: (event: ObcPaginationNavigateEvent) => emit('navigate', event as ObcPaginationNavigateEvent)
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-pagination',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})